import React from 'react';

const GuestInviteStep = ({ preference, onChange, onBack, onNext }) => (
  <div className="modal-step guest-invite-step">
    <h5>Would you like to bring a guest for Free?</h5>
    <form className="option-list">
      <label>
        <input
          type="radio"
          name="guestInvite"
          value="yes"
          checked={preference === 'yes'}
          onChange={() => onChange('yes')}
        />
        Yes
      </label>

      <label>
        <input
          type="radio"
          name="guestInvite"
          value="no"
          checked={preference === 'no'}
          onChange={() => onChange('no')}
        />
        No
      </label>
    </form>

    <div className="modal-form-actions">
      <button type="button" className="class-modal-submit" onClick={onBack}>
        ← PREV
      </button>
      <button
        type="button"
        className="class-modal-submit"
        onClick={onNext}
        disabled={!preference}
      >
        {preference === 'yes' ? 'Next →' : 'Submit'}
      </button>
    </div>
  </div>
);

export default GuestInviteStep;

